const model = require('model/model');
const assignmentService = require('services/assignmentService');
const beatriceDataMap = require('beatrice-data-map');

const setStudentResearchAssessments = assessments => {
	model.remove('researchAssessments');

	const mapped = Array.isArray(assessments) ? assessments.map(a => beatriceDataMap.studentResearchAssessment.serverToClient(a)) : assessments;

	model.set('researchAssessments', mapped);

	return assessments;
};

const getStudentResearchAssessments = () => {
	return assignmentService.getStudentResearchAssessments().then(setStudentResearchAssessments);
};

const teacherGetStudentResearchAssessments = cc => {
	return assignmentService.teacherGetStudentResearchAssessments({ cc }).then(setStudentResearchAssessments);
};

const getStudentResearchAssessmentProduct = type => {
	return assignmentService.getStudentResearchAssessmentProduct({ type });
};

const submitStudentResearchAssessment = (answers, sraid) => {
	return assignmentService.submitStudentResearchAssessment({
		answers,
		sraid
	});
};

module.exports = {
	getStudentResearchAssessments,
	teacherGetStudentResearchAssessments,
	getStudentResearchAssessmentProduct,
	submitStudentResearchAssessment
};
